button-video-modal {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
button-video-modal svg {
  position: absolute;
  top: calc(50% - 3rem);
  left: calc(50% - 3rem);
  display: none;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 6rem;
  border: 5px solid #000;
  background-size: 3rem;
  border-radius: 50%;
  padding: 1.5rem;
  fill: #000;
}
button-video-modal picture + svg {
  display: inline-flex;
}
button-video-modal:hover {
  border-color: var(--brand-primary, #FF6600);
  fill: var(--brand-primary, #FF6600);
}